/**
 * Las secciones de Emails en el orden del menú lateral (como las de WhatsApp: `wa-oficial/components/SeccionesOficial.ts`).
 * «Conexión» es del equipo: las casillas y el calentamiento de la cuenta de Snov de Deenex y de qué comercio es cada
 * campaña. Labels cortos: el menú expandido deja ~117 px de texto.
 */

import type { LucideIcon } from "lucide-react";
import { LayoutDashboard, ListChecks, MessageSquareReply, PlugZap, Send, Users } from "lucide-react";
import { R_EMAILS } from "./logic/emails";

export interface SeccionEmails {
  label: string;
  title: string;
  path: string;
  icono: LucideIcon;
  end: boolean;
  soloEquipo?: boolean;
}

export const SECCIONES_EMAILS: SeccionEmails[] = [
  { label: "Resumen", title: "Cómo les fue a los mails", path: R_EMAILS, icono: LayoutDashboard, end: true },
  { label: "Acciones", title: "Qué hacer con lo que dicen los mails", path: `${R_EMAILS}/acciones`, icono: ListChecks, end: false },
  { label: "Campañas", title: "Campañas de mail", path: `${R_EMAILS}/campanas`, icono: Send, end: false },
  { label: "Personas", title: "Personas que recibieron los mails", path: `${R_EMAILS}/personas`, icono: Users, end: false },
  { label: "Respuestas", title: "Lo que contestaron", path: `${R_EMAILS}/respuestas`, icono: MessageSquareReply, end: false },
  { label: "Conexión", title: "Conexión con Snov", path: `${R_EMAILS}/conexion`, icono: PlugZap, end: false, soloEquipo: true },
];

export function seccionesEmailsPara(equipo: boolean): SeccionEmails[] {
  return SECCIONES_EMAILS.filter((s) => equipo || !s.soloEquipo);
}
